import taskTracker from '@/services/simple-task-tracker'

export default {
  install(Vue) {
    // Add to Vue prototype for easy access
    Vue.prototype.$taskTracker = taskTracker
    
    // Auto-cleanup on component destroy
    Vue.mixin({
      beforeDestroy() {
        // Simple cleanup - just disconnect if this is the last component
        if (taskTracker.activeTasks.size === 0) {
          taskTracker.disconnect()
        }
      }
    })
  }
}
